var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4526 23L13.2926 16.8693L15.7566 14.4053L21.8873 20.536L19.4526 23ZM12.002 23C9.88998 23 8.06643 22.5404 6.53132 21.6213C5.00598 20.7022 3.82776 19.4164 2.99665 17.764C2.17532 16.1116 1.76465 14.1902 1.76465 12C1.76465 9.80978 2.17532 7.88844 2.99665 6.236C3.82776 4.58356 5.00598 3.29778 6.53132 2.37867C8.06643 1.45956 9.88998 1 12.002 1C14.114 1 15.9326 1.45956 17.458 2.37867C18.9931 3.29778 20.1713 4.58356 20.9927 6.236C21.8238 7.88844 22.2393 9.80978 22.2393 12C22.2393 14.1902 21.8238 16.1116 20.9927 17.764C20.1713 19.4164 18.9931 20.7022 17.458 21.6213C15.9326 22.5404 14.114 23 12.002 23ZM12.002 19.2453C13.3415 19.2649 14.4562 18.9764 15.346 18.38C16.2358 17.7836 16.9006 16.9378 17.3407 15.8427C17.7904 14.7476 18.0153 13.4667 18.0153 12C18.0153 10.5333 17.7904 9.26222 17.3407 8.18667C16.9006 7.11111 16.2358 6.27511 15.346 5.67867C14.4562 5.08222 13.3415 4.77422 12.002 4.75467C10.6624 4.73511 9.54776 5.02356 8.65798 5.62C7.7682 6.21644 7.09843 7.06222 6.64865 8.15733C6.20865 9.25244 5.98865 10.5333 5.98865 12C5.98865 13.4667 6.20865 14.7378 6.64865 15.8133C7.09843 16.8889 7.7682 17.7249 8.65798 18.3213C9.54776 18.9178 10.6624 19.2258 12.002 19.2453Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ);
export default __webpack_public_path__ + "static/media/Q.f1bdc260726e7e6d08fefbef174127ea.svg";
export { ForwardRef as ReactComponent };